import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import dayjs from "dayjs";

export default function Details() {
    const { id } = useParams();
    const [ appointment, setAppointment ] = useState([]);

    useEffect(() => { 
        axios.post('http://localhost:5000/Appointments/GetAppointment', { id: id})
        .then((response) =>  {
            setAppointment(response.data[0]);
        })
        .catch((error) => { 
            console.log(error);
        })
    });

    useEffect(() => { 
        axios.post('http://localhost:5000/Appointments/GetAppointment', { id: id})
            .then((response) =>  {
                setAppointment(response.data[0]);
            })
            .catch((error) => { 
                console.log(error);
            });
    }, [appointment]);

    return(
        <React.Fragment>
            <main>
                <h1>Appointment Details</h1>
                <span>
                <Link to="/Admin/Appointments" className="btn btn-secondary">Back</Link>
                </span>
                <section>
                    <article>
                        <dl>
                            <dt>ID:</dt>
                            <dd>{appointment._id}</dd><br />
                            <dt>User:</dt>
                            <dd>{appointment.userId}</dd>
                            <dt>Department:</dt>
                            <dd>{appointment.department}</dd>
                            <dt>Doctor:</dt>
                            <dd>{appointment.doctor}</dd>
                            <dt>Description:</dt>
                            <dd>{appointment.description}</dd>
                            <dt>From:</dt>
                            <dd>{dayjs(appointment.from).format("dddd, MMMM D YYYY, h:mm:ss A")}</dd>
                            <dt>To:</dt>
                            <dd>{dayjs(appointment.to).format("dddd, MMMM D YYYY, h:mm:ss A" )}</dd>
                        </dl>
                    </article>
                </section>
            </main>
        </React.Fragment>
    )
} 